import React, { useRef, useState } from "react";
import styled from "styled-components";
import mq from "../../helpers/media-queries";
import Sidebar from "./Packages/Sidebar";
import { ConfigurationProvider } from "./Deluxe/ConfigurationContext";
import { SketchfabProvider } from "../Sketchfab/SketchfabContext";
import RenderContainer from "../RenderContainer/RenderContainer";
import RenderIframe from "./Deluxe/RenderIframe";
import { ReactComponent as RoyalTubsLogo } from "../../assets/img/royaltubs-logo.svg";
import { rem } from "polished";
import { useLocation } from "react-router-dom";

const Container = styled.div`
    ${mq("sm", "min")} {
        height: 100%;
        display: flex;
    }
`;

const Back = styled.a`
    font-weight: 400;
    font-size: 12px;
    font-family: sans-serif;
    color: #5a4a44;
    text-decoration: none;
    position: absolute;
    top: 27px;
    left: 42px;
    display: flex;

    img {
        height: 12px;
        margin-right: ${rem(8)};
    }
`;

const LogoContainer = styled.div`
    display: none;

    ${mq("desktop", "min")} {
        position: absolute;
        width: 150px;
        left: 40px;
        top: 20px;
        display: block;
        left: 50%;
        transform: translateX(-50%);
    }

    svg {
        width: 100%;
    }
`;

const Headline = styled.h1`
    display: none;

    ${mq("sm", "min")} {
        font-family: "Tiempos Headline";
        position: absolute;
        padding: 24px 0;
        font-size: 30px;
        line-height: 1.3;
        color: #5b5a50;
        display: block;
    }
`;

const PackagesPage = ({
    title,
    packages,
    breadcrumbData,
    checkBoxesData,
    keyFeaturesData,
    limitedOfferIntroData,
    headlineData,
}) => {
    const { pathname: path } = useLocation();
    const viewerRef = useRef(null);
    const [modelId, setModelId] = useState(keyFeaturesData.modelId);
    const [modelNodes, setmodelNodes] = useState(keyFeaturesData.modelNodes);

    return (
        <ConfigurationProvider>
            <SketchfabProvider
                modelUID={modelId}
                initialNodes={modelNodes.initial ? modelNodes.initial : ""}
                viewerRef={viewerRef}
            >
                <Container>
                    <RenderContainer relative={true}>
                        <LogoContainer>
                            <a href="/">
                                <RoyalTubsLogo />
                            </a>
                        </LogoContainer>
                        <RenderIframe viewerRef={viewerRef} />
                    </RenderContainer>
                    <Sidebar
                        title={title}
                        packages={packages}
                        path={path}
                        breadcrumbData={breadcrumbData}
                        checkBoxesData={checkBoxesData}
                        limitedOfferIntroData={limitedOfferIntroData}
                        headlineData={headlineData}
                        keyFeaturesData={keyFeaturesData}
                        modelId={modelId}
                        setModelId={setModelId}
                        setmodelNodes={setmodelNodes}
                    />
                </Container>
            </SketchfabProvider>
        </ConfigurationProvider>
    );
};

export default PackagesPage;
